/** This visit's sends, by workspace and person. A module-level map, **not browser storage**: it
 * survives a trip to the review screen and back (the SPA does not reload) and nothing else - a reload
 * clears it, and a different person in the same tab never sees it because the key names both. */

import type { BatchEntry } from "./BatchTable";

const SESSION_BATCHES = new Map<string, BatchEntry[]>();
let batchCounter = 0;

export const nextBatchKey = (): string => `send-${(batchCounter += 1)}`;

export function saveBatch(key: string, entries: BatchEntry[]): void {
  SESSION_BATCHES.set(key, entries);
}

/** The batch as it was left; a send that never reported back is said to be unconfirmed. */
export function restoreBatch(key: string): BatchEntry[] {
  return (SESSION_BATCHES.get(key) ?? []).map((entry) =>
    entry.status === "sending"
      ? { ...entry, status: "failed" as const, note: "Not confirmed: the screen was left while this was sending." }
      : entry,
  );
}

/** For tests: forget every batch. */
export function resetSessionBatches(): void {
  SESSION_BATCHES.clear();
}
